import { useTranslation } from "react-i18next";
import { Button, Form } from "antd";

import { ReactComponent as Warning } from "assets/icons/warning-orange-triangle.svg";

import Input from "components/inputs";

const VoucherForm = ({ error, loading, onFinish }) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  const codeWatch = Form.useWatch("code", form);

  const disabled = ["", null, undefined].includes(codeWatch);

  return (
    <Form
      className="h-full"
      autoComplete="off"
      form={form}
      name="voucher-form"
      onFinish={onFinish}
    >
      <>
        <img
          src={"https://cdn.firouzeh.com/public/voucher-ticket.png"}
          alt={t("voucher.title")}
          className="w-[100px] h-auto m-auto table"
        />

        <p className="my-4 body-14px-regular text-gray-4">
          {t("voucher.firouzeh-code")}
        </p>
        <Input
          inputClassName={`text-right transition-all delay-50 ${
            error ? "!border-error-0" : ""
          }`}
          label={t("voucher.coupon")}
          name="code"
          type="text"
          required
          validateTrigger="onChange"
        />
        {error && (
          <div className="text-error-0 caption-12px-medium mt-2 flex gap-1 items-center">
            <Warning className=" [&>path]:fill-error-0 w-3.5 h-3.5" />
            <span> {error}</span>
          </div>
        )}
        <div className="absolute border-t border-gray--7  w-[calc(100%+40px)] p-5 -right-5 -bottom-5">
          <Button
            disabled={disabled}
            loading={loading}
            className={`${
              disabled ? "disabled-button-large" : "primary-button-large"
            } justify-center items-center `}
            block
            htmlType="submit"
          >
            {t("submit")}
          </Button>
        </div>
      </>
    </Form>
  );
};

export default VoucherForm;
